import { render, staticRenderFns } from "./orderDetailYG.vue?vue&type=template&id=a9a65d62&scoped=true"
import script from "./orderDetailYG.vue?vue&type=script&lang=ts"
export * from "./orderDetailYG.vue?vue&type=script&lang=ts"
import style0 from "./orderDetailYG.vue?vue&type=style&index=0&id=a9a65d62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9a65d62",
  null
  
)

export default component.exports